export const ordersEndPoints = {
  getList: (queryString: string) => `/orders/list${queryString}`,
};
